import gsap from "gsap";
import horizontalMarquee from "../horizontalMarquee";
import awardsFlip from "../awards-flip";

import { isLandingPage, IS_TABLET_SM, DOM } from '../../helpers/consts';

export default () => {
	if (!isLandingPage) return;
	console.log('Its landing')
	const sections = document.querySelectorAll('.js-landing-marquees-section');
	sections.forEach((section, index) => {
		const boxes = section.querySelectorAll('.horizontal__marquee__part');
		if (boxes.length) {
			const loop = horizontalMarquee(boxes, {
				paused: false,
				repeat: -1,
				reversed: false,
				speed: 0.5,
			});
		} else {
			console.warn(`No boxes found in section ${index}`);
		}
	});

	DOM.header.classList.add('is-blue');

	const hasLandingLogo= document.querySelector('.js-landing-logo');

	if (hasLandingLogo) {

		// Use GSAP's delayedCall to wait for 2 seconds before running the animation code
		gsap.delayedCall(1.5, () => {
			// Animate the 'js-landing-logo__side' group to fade in up for 200ms
			gsap.from(".js-landing-logo__side", {
				duration: 0.2, // 200ms
				opacity: 0,
				y: 20, // move up a bit before fading in for the "fade up" effect
				ease: "power1.out",
			});

			// Find all paths within 'js-landing-logo__text' and sort them by their ID to ensure they're animated in order
			const paths = Array.from(document.querySelectorAll('.js-landing-logo__text path'))
				.sort((a, b) => parseInt(a.id, 10) - parseInt(b.id, 10));

			// Animate these paths to fade in left, staggered, with an offset of 3 pixels between each animation
			gsap.from(paths, {
				duration: 0.5, // half a second for each path to fade in
				opacity: 0,
				x: -3, // move left a bit before fading in
				stagger: 0.1, // stagger start times by 100ms
				ease: "power1.out",
			});
		});

	}

	// Sticky video block
	const video = document.querySelector('.social-section__media-item');

	if (!video || IS_TABLET_SM){ return }

	gsap.to(video, {
		scrollTrigger: {
			trigger: ".landing__checklist__column1",
			start: "top 20px", // Start when the video column top hits 20px from the top of the viewport
			end: () => `bottom-=${video.offsetHeight + 20}px`, // Dynamically calculated end point
			pin: true,
			pinSpacing: false,
			scrub: true,
			markers: false // Use true for debugging
		}
	});

	// Add awards flip support to landing page
	awardsFlip()


};

